/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddonProvisionProjectRequestOneOf1
 */
export interface AddonProvisionProjectRequestOneOf1 {
    /**
     * 
     * @type {string}
     * @memberof AddonProvisionProjectRequestOneOf1
     */
    addonType: string;
    /**
     * 
     * @type {string}
     * @memberof AddonProvisionProjectRequestOneOf1
     */
    token: string;
    /**
     * 
     * @type {string}
     * @memberof AddonProvisionProjectRequestOneOf1
     */
    projectName: string;
}

/**
 * Check if a given object implements the AddonProvisionProjectRequestOneOf1 interface.
 */
export function instanceOfAddonProvisionProjectRequestOneOf1(value: object): value is AddonProvisionProjectRequestOneOf1 {
    if (!('addonType' in value) || value['addonType'] === undefined) return false;
    if (!('token' in value) || value['token'] === undefined) return false;
    if (!('projectName' in value) || value['projectName'] === undefined) return false;
    return true;
}

export function AddonProvisionProjectRequestOneOf1FromJSON(json: any): AddonProvisionProjectRequestOneOf1 {
    return AddonProvisionProjectRequestOneOf1FromJSONTyped(json, false);
}

export function AddonProvisionProjectRequestOneOf1FromJSONTyped(json: any, ignoreDiscriminator: boolean): AddonProvisionProjectRequestOneOf1 {
    if (json == null) {
        return json;
    }
    return {
        
        'addonType': json['addonType'],
        'token': json['token'],
        'projectName': json['projectName'],
    };
}

export function AddonProvisionProjectRequestOneOf1ToJSON(json: any): AddonProvisionProjectRequestOneOf1 {
    return AddonProvisionProjectRequestOneOf1ToJSONTyped(json, false);
}

export function AddonProvisionProjectRequestOneOf1ToJSONTyped(value?: AddonProvisionProjectRequestOneOf1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'addonType': value['addonType'],
        'token': value['token'],
        'projectName': value['projectName'],
    };
}

